export default __webpack_public_path__ + "static/media/background-1440.47dc69c4.jpg";